module.exports = __webpack_public_path__ + "static/media/svg-10.ba186dd7.svg";